/**
 * System limits for record operations.
 * These constants define the maximum supported record counts for various operations.
 */

export const MAX_STRING_FILTER_COMBINATIONS = 4

/**
 * Pro account limits
 */
export const PRO_ACCOUNT_MAX_RECORDS = 40000
export const PRO_ACCOUNT_MAX_FIELDS = 10
export const CONTACT_SALES_URL = "https://blindinsight.com/contact"

/**
 * Pro / paid tier from organization Stripe settings (subscription is org-scoped).
 * @param {Object | null | undefined} org - Current organization from store / API
 * @returns {boolean}
 */
export function isProAccount(org) {
  if (!org?.settings?.stripe) {
    return false
  }
  const productName = org.settings.stripe.product_name
  return productName && productName !== "Free"
}
